module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"../config/components.json","commonjs":"../config/components.json"}
// module id = 389
// module chunks = 1